import { render, staticRenderFns } from "./PlaceFields.vue?vue&type=template&id=5895c832&scoped=true"
import script from "./PlaceFields.vue?vue&type=script&lang=js"
export * from "./PlaceFields.vue?vue&type=script&lang=js"
import style0 from "./PlaceFields.vue?vue&type=style&index=0&id=5895c832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895c832",
  null
  
)

export default component.exports